const react = require('react');
const { useParams } = require('react-router-dom');

const ReScheduler = () => {

    const { guideID, noteID, confirmationCode } = useParams();

    const [customerName, setCustomerName] = react.useState("");
    const [customerProfilePictureURL, setCustomerProfilePictureURL] = react.useState("");
    const [customerMessage, setCustomerMessage] = react.useState("");
    const [originalCallTime, setOriginalCallTime] = react.useState("");
    const [originalCallTimeZone, setOriginalCallTimeZone] = react.useState("");
    const [showCustomerInfo, setShowCustomerInfo] = react.useState(false);

    const getData = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/guide/rescheduler-data/${guideID}/note/${noteID}/${confirmationCode}`);
            const data = await response.json();
            const { customerName, customerProfilePictureURL, customerMessage, originalCallTime, originalCallTimeZone } = data;
            setCustomerName(customerName);
            setCustomerProfilePictureURL(customerProfilePictureURL);
            setCustomerMessage(customerMessage);
            setOriginalCallTime(originalCallTime);
            setOriginalCallTimeZone(originalCallTimeZone);
        } catch (error) {
            console.error("Error fetching reschedule data:", error);
        }
    };

    react.useEffect(() => {
        getData();
    }, [guideID, noteID, confirmationCode]);
    return (
        <div>
            <h1>ReScheduler the Call with {customerName}</h1>
            <button onClick={() => setShowCustomerInfo(true)}>View Customer Info</button>
            {showCustomerInfo && (
                <div>
                    <img style={{width: "150px", height: "auto"}} src={customerProfilePictureURL} alt={`${customerName}'s profile picture`} />
                    <p>Message from Customer: {customerMessage}</p>
                    <p>Original Scheduled Call Time: {originalCallTime}</p>
                </div>
            )}
        </div>
    );
}

export default ReScheduler;